import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import GoogleSignInButton from '../../components/GoogleSignInButton';
import { CheckmarkIcon } from '../../assets/icons/CheckmarkIcon';
import { useTranslation } from '../../contexts/TranslationContext';
import { RegisterFormState } from './registerTypes';

interface RegisterStepAccountProps {
  form: RegisterFormState;
  update: (patch: Partial<RegisterFormState>) => void;
  onBack: () => void;
  onSubmit: (e: React.FormEvent) => void;
  onNotExpertToggle: (skip: boolean) => void;
  error: string;
  success: string;
}

const RegisterStepAccount: React.FC<RegisterStepAccountProps> = ({
  form,
  update,
  onBack,
  onSubmit,
  onNotExpertToggle,
  error,
  success,
}) => {
  const { t } = useTranslation();

  return (
    <div className="register__card">
      <h1 className="register__title italic-title">{t.register.accountTitle}</h1>
      <p className="register__subtitle">{t.register.accountSubtitle}</p>

      <form className="register__form" onSubmit={onSubmit}>
        <div className="register__field">
          <label htmlFor="email" className="register__label">{t.register.email}</label>
          <input
            id="email"
            className="register__input"
            type="email"
            value={form.email}
            onChange={(e) => update({ email: e.target.value })}
            required
          />
        </div>
        <div className="register__field">
          <label htmlFor="password" className="register__label">{t.register.password}</label>
          <input
            id="password"
            className="register__input"
            type="password"
            value={form.password}
            onChange={(e) => update({ password: e.target.value })}
            required
          />
        </div>
        <div className="register__field">
          <label htmlFor="repeatPassword" className="register__label">{t.register.repeatPassword}</label>
          <input
            id="repeatPassword"
            className="register__input"
            type="password"
            value={form.repeatPassword}
            onChange={(e) => update({ repeatPassword: e.target.value })}
            required
          />
        </div>
        <div className="register__field">
          <label htmlFor="birthdate" className="register__label">{t.register.birthdate}</label>
          <DatePicker
            id="birthdate"
            selected={form.birthdate}
            onChange={(date: Date | null) => update({ birthdate: date })}
            dateFormat="yyyy-MM-dd"
            className="register__datepicker"
            wrapperClassName="register__datepicker-wrapper"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            maxDate={new Date()}
            required
          />
        </div>

        <label className="register__skip-toggle">
          <input
            type="checkbox"
            className="sr-only"
            checked={form.skipExpert}
            onChange={(e) => onNotExpertToggle(e.target.checked)}
          />
          <span className="register__skip-toggle-track" aria-hidden />
          <span className="register__skip-toggle-copy">
            {t.register.notExpertLink}
            <span className="register__skip-toggle-subline">{t.register.notExpertSubline}</span>
          </span>
        </label>

        <div className="register__nav">
          <button type="button" className="register__back" onClick={onBack}>
            {t.register.back}
          </button>
          <button type="submit" className="register__submit button_primary">
            {t.register.submit}
          </button>
        </div>
        <GoogleSignInButton className="home__google-button" />
      </form>

      {(error || success) && (
        <div
          className={
            success
              ? 'register__feedback register__feedback--success'
              : 'register__feedback register__feedback--error'
          }
        >
          {success ? (
            <div className="register__feedback__success">
              <CheckmarkIcon className="register__feedback__check-icon" aria-hidden />
              <span>{success}</span>
            </div>
          ) : (
            <div className="register__feedback__error">{error}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default RegisterStepAccount;
